import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function OrderCancel() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4" data-testid="order-cancel-page">
      <div className="max-w-lg w-full bg-white border border-border p-10 offset-shadow">
        <XCircle className="text-brand-red mb-4" size={48} />
        <h1 className="font-heading text-3xl mb-2">Payment cancelled</h1>
        <p className="text-muted-foreground mb-6">No charge was made. Your order request is still on file — you can pay online again or choose pay-on-delivery.</p>
        <Link to="/#order" className="inline-block bg-brand-red text-white px-6 py-3 font-bold" data-testid="cancel-back-btn">Back to order form</Link>
      </div>
    </div>
  );
}
